import { SiteShell } from "../pages/Landing";
import { langPath } from "../seo/site";
import SampleQuiz, { StoreLinks } from "./SampleQuiz";
import { PRACTICE, TRAFIKVERKET_URL, practicePath } from "./practiceContent";
import { PRACTICE_CSS } from "./practiceStyles";

/* ============================================================================
   Practice test page: /sv/ovningsprov/, /en/practice-test/, /uk/probnyi-test/,
   /ru/probnyj-test/

   Everything except the quiz itself is plain text that is prerendered into
   the HTML (scripts/prerender.js), so search engines can read it. The quiz
   (SampleQuiz.js) loads its questions only when the visitor presses Start.

   Texts: practiceContent.js · Styles: practiceStyles.js
   ========================================================================== */

export default function PracticePage({ lang }) {
  const p = PRACTICE[lang];
  const home = langPath(lang);

  return (
    <SiteShell lang={lang} hrefFor={practicePath}>
      <style>{PRACTICE_CSS}</style>
      <main className="tk-pr">
        {/* Visible breadcrumb — matches the BreadcrumbList structured data. */}
        <nav className="tk-crumbs" aria-label="Breadcrumb">
          <ol>
            <li><a href={home}>{p.breadcrumbHome}</a></li>
            <li aria-current="page">{p.navLabel}</li>
          </ol>
        </nav>

        <header className="tk-pr-header">
          <h1>{p.h1}</h1>
          <p className="tk-pr-lead">{p.intro}</p>
        </header>

        <SampleQuiz lang={lang} text={p.quiz} />

        <section className="tk-pr-section">
          <h2>{p.howTitle}</h2>
          {p.how.map((paragraph, i) => <p key={i}>{paragraph}</p>)}
          <p>
            <a href={TRAFIKVERKET_URL} target="_blank" rel="noopener noreferrer">{p.howSource} →</a>
          </p>
        </section>

        <section className="tk-pr-section">
          <h2>{p.topicsTitle}</h2>
          <ul className="tk-pr-topics">
            {p.topics.map(([name, description]) => (
              <li key={name}><strong>{name}</strong> – {description}</li>
            ))}
          </ul>
        </section>

        <section className="tk-pr-section">
          <h2>{p.tipsTitle}</h2>
          <ol className="tk-pr-tips">
            {p.tips.map((tip) => <li key={tip}>{tip}</li>)}
          </ol>
        </section>

        <section className="tk-pr-section tk-pr-cta" data-track-placement="practice_cta">
          <h2>{p.quiz.ctaTitle}</h2>
          <p>{p.quiz.ctaText}</p>
          <StoreLinks text={p.quiz} />
        </section>

        <section className="tk-pr-section">
          <h2>{p.relatedTitle}</h2>
          <ul className="tk-pr-links">
            <li><a href={home}>{p.related.app}</a></li>
            <li><a href={`${home}#faq`}>{p.related.faq}</a></li>
            <li><a href={TRAFIKVERKET_URL} target="_blank" rel="noopener noreferrer">{p.related.official}</a></li>
          </ul>
        </section>
      </main>
    </SiteShell>
  );
}
